module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"common-carousel\" class=\"carousel slide\" data-interval=\"false\">\r\n    <div class=\"carousel-inner\">\r\n        <div class=\"item active\">\r\n            <div class=\"col-sm-1 nopadding factory-widget toolbar-button-container asset_new\" draggable=\"false\" id=\"asset_new\" style=\"\r\n            margin-left: 10px !important;\">\r\n                <div class=\"thumb ui-widget-header toolbar-button\">\r\n                    <p class=\"assets-top\">Add<br>Image</p>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"col-sm-1  nopadding factory-widget toolbar-button-container asset_delete\" draggable=\"false\" id=\"asset_delete\" style=\"\r\n            margin-left: 5px !important;\r\n            margin-right: 5px !important;\">\r\n                <div class=\"thumb ui-widget-header toolbar-button btn-disabled\">\r\n                    <p class=\"assets-top\">Delete Image</p>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div> <!-- carousel-inner -->\r\n\r\n    <a class=\"left carousel-control\" href=\"#common-carousel\" role=\"button\" data-slide=\"prev\">\r\n        <span class=\"fa fa-angle-left\"></span>\r\n    </a>\r\n    <a class=\"right carousel-control\" href=\"#common-carousel\" role=\"button\" data-slide=\"next\">\r\n        <span class=\"fa fa-angle-right\"></span>\r\n    </a>\r\n</div><!-- thumbcarousel -->")
  }
  return __output;

}